import { useLayoutEffect } from 'react';

export const useLockBody = (lock: boolean) => {
  useLayoutEffect(() => {
    if (!lock) return;
    const y = window.scrollY;
    const prev = {
      pos: document.body.style.position,
      top: document.body.style.top,
      ovf: document.body.style.overflow,
      w: document.body.style.width,
    };
    document.body.style.position = 'fixed';
    document.body.style.top = `-${y}px`;
    document.body.style.overflow = 'hidden';
    document.body.style.width = '100%';
    return () => {
      document.body.style.position = prev.pos;
      document.body.style.top = prev.top;
      document.body.style.overflow = prev.ovf;
      document.body.style.width = prev.w;
      window.scrollTo(0, y);
    };
  }, [lock]);
};
